import { GlassPanel } from '@/components/sections/GlassPanel'

export const HowItWorksHero = () => (
  <GlassPanel className="hero w-hero" shade="hero" labelledBy="w-title">
    <div className="nav-space" aria-hidden="true" />
    <div className="hero-text">
      <div className="hero-text-copy">
        <p className="x-eyebrow x-eyebrow--ink">How it works</p>
        <h1 id="w-title" className="display w-hero-title">
          Co-owners on the same team
        </h1>
        <p className="hero-lead">
          We invest into your firm, then build its future with you and your team, one bottleneck at a time.
        </p>
      </div>
    </div>
  </GlassPanel>
)
